export default {
  init: async () => {
    const tooltips = document.querySelectorAll("[data-tooltip]");

    if (!tooltips.length) {
      return;
    }

    const { default: tippy } = await import("tippy.js");
    await import("tippy.js/dist/tippy.css");
    await import("tippy.js/themes/translucent.css");

    tippy("[data-tooltip]", {
      theme: "translucent",
      allowHTML: true,
      interactive: true,
      trigger: "click",
      content: (ref) => {
        return document.getElementById(ref.getAttribute("aria-describedby")).innerHTML;
      },
    });
  },
};
